var map = {
	"../pages/address/address.module": [
		1054,
		8
	],
	"../pages/addresses/addresses.module": [
		1055,
		12
	],
	"../pages/contacts/contacts.module": [
		1056,
		11
	],
	"../pages/history/history.module": [
		1057,
		2
	],
	"../pages/home/home.module": [
		1066,
		1
	],
	"../pages/more/more.module": [
		1058,
		10
	],
	"../pages/send/send.module": [
		1065,
		3
	],
	"../pages/settings/settings.module": [
		1059,
		9
	],
	"../pages/sign/sign.module": [
		1061,
		4
	],
	"../pages/sweep/sweep.module": [
		1060,
		0
	],
	"../pages/wif/wif.module": [
		1062,
		7
	],
	"../pages/xpub/xpub.module": [
		1063,
		6
	],
	"../pages/xrpv/xprv.module": [
		1064,
		5
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 365;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 365
// module chunks = 13